import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import loader from "../../../assets/images/logo.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Button from "@material-ui/core/Button";
import {
  UserloggedContext,
  WatchLaterVideosContext,
  ActiveTabsContext,
} from "../../Context/UserContext";
import ApiEndPoint from "../../../utils/apiEndPoints";
import { setDefaultHeader, apiCall } from "../../../utils/httpClient";
import {
  AllImages,
  VideoPlaylistShareUrl,
  GLOBAL_URL,
  RemoveDuplicates,
  emojiRegex,
  getImageNameFromResolution,
} from "../../../utils/constants";
import "./style.css";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { RWebShare } from "react-web-share";
import NoDataAvailable from "../../common/NoDataFound/NoDataAvailable";
import { CiCircleList } from "react-icons/ci";
import { CiGrid2V } from "react-icons/ci";
const SortingOptions = {
  NEWLY_ADDED: "NEWLY_ADDED",
  PREVIOUSLY_ADDED: "PREVIOUSLY_ADDED",
  POPULAR_VIDEOS: "POPULAR_VIDEOS",
  NEWLY_PUBLISHED: "NEWLY_PUBLISHED",
  PREVIOUSLY_PUBLISHED: "PREVIOUSLY_PUBLISHED",
  LAST_MODIFIED_DATE: "LAST_MODIFIED_DATE",
  Sort_A_To_Z: "A_TO_Z",
  Sort_Z_To_A: "Z_TO_A",
};
const WatchLater = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [auth, setAuth] = useContext(UserloggedContext);
  const [watchLaterVideos, setWatchLaterVideos] = useContext(
    WatchLaterVideosContext
  );
  const [isListView, setIsListView] = useState(false);
  const [activetabs, setActiveTabs] = useContext(ActiveTabsContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [watchLaterPlaylist, setWatchLaterPlayList] = useState([]);
  const [selectedFilterOp, setSelectedFilterOp] = useState(
    SortingOptions.LAST_MODIFIED_DATE
  );

  const [tabValue, setTabValue] = React.useState(
    activetabs.filter((item) => item.page == "watchLater")[0].active
  );

  const [pageNo, setPageNo] = useState(0);
  const [scrollLast, setScrollLast] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    fetchData();
  }, [tabValue, selectedFilterOp]);
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      fetchData();
    }
  };
  const fetchData = () => {
    setHasMore(true);

    tabValue === "videos" ? watchLaterVideolist(1) : watchLaterPlaylistFun(1);
  };
  const fetchMoreData = () => {
    tabValue === "videos" ? watchLaterVideolist() : watchLaterPlaylistFun();
  };
  async function watchLaterVideolist(fetchPage = 0) {
    try {
      if (auth) {
        const params = {
          searchValue: searchText,
          sortColumn: selectedFilterOp,
          sortDirection: "",
          pageNo: fetchPage ? fetchPage - 1 : pageNo,
          pageSize: 20,
        };

        const { data } = await apiCall(
          "POST",
          `${ApiEndPoint.ALLWATCHLATERVIDEOS}`,
          params
        );
        if (data.length > 0) {
          // setWatchLaterVideos(fetchPage?data:prev=>[...prev,...data]);
          setIsLoading(false);
          setWatchLaterVideos(
            RemoveDuplicates(fetchPage ? data : watchLaterVideos.concat(data))
          );
          setPageNo(fetchPage ? fetchPage : pageNo + 1);
          setHasMore(data.length == 20);
          setScrollLast(true);
        } else {
          setIsLoading(false);
          fetchPage && setWatchLaterVideos([]);
          setHasMore(false);
          setScrollLast(false);
          setPageNo(0);
        }
      }
    } catch (err) {
      setIsLoading(false);
      setHasMore(false);
      setScrollLast(false);
    }
    isOpenSortBy && closeModalSortBy();
  }

  async function watchLaterPlaylistFun(fetchPage = 0) {
    if (
      ![
        "NEWLY_ADDED",
        "LAST_MODIFIED_DATE",
        "PREVIOUSLY_ADDED",
        "A_TO_Z",
        "Z_TO_A",
      ].includes(selectedFilterOp)
    ) {
      setSelectedFilterOp(SortingOptions.NEWLY_ADDED);
      return;
    }
    try {
      if (auth) {
        const params = {
          searchValue: searchText,
          sortColumn: selectedFilterOp,
          sortDirection: "",
          pageNo: fetchPage ? fetchPage - 1 : pageNo,
          pageSize: 20,
        };
        setIsLoading(true);

        const { data } = await apiCall(
          "POST",
          `${ApiEndPoint.WATCHLATERPLAYLIST}`,
          params
        );

        if (data.length > 0) {
          // setWatchLaterPlayList(fetchPage?data:prev=>[...prev,...data]);
          setWatchLaterPlayList(
            RemoveDuplicates(fetchPage ? data : watchLaterPlaylist.concat(data))
          );

          setIsLoading(false);
          setPageNo(fetchPage ? fetchPage : pageNo + 1);
          setHasMore(data.length == 20);
          setScrollLast(true);
        } else {
          setIsLoading(false);
          fetchPage && setWatchLaterPlayList([]);
          setPageNo(0);
          setHasMore(false);
          setScrollLast(false);
        }
      }
    } catch (err) {
      setIsLoading(false);
      setHasMore(false);
      setScrollLast(false);
    }
    isOpenSortBy && closeModalSortBy();
  }

  const handleVideoClick = (item) => {
    navigate(`/videoPlayPage/${item.id}`);
  };

  const addFavorite = async (item, index) => {
    if (auth) {
      watchLaterVideos[index].myFavourite = item.myFavourite ? false : true;
      try {
        const { data } = await apiCall("POST", `/my-favourites/${item.id}`);
        if (data) {
          setRefresh(!refresh);
        } else {
          setRefresh(!refresh);
        }
      } catch (err) {
        setRefresh(!refresh);
        console.log("err: ", err);
      }
    } else {
      // setGoogleLoginShow(true)
    }
  };

  const videoWatchLater = async (item, index) => {
    if (auth) {
      try {
        const { data } = await apiCall(
          "DELETE",
          `${ApiEndPoint.WATCHLATEDREMOVE}/${item.id}`
        );
        if (data) {
          const removeWatchLatedVieo = watchLaterVideos.filter(
            (x) => x.id != item.id
          );
          setWatchLaterVideos(removeWatchLatedVieo);
          if (removeWatchLatedVieo.length <= 1) {
            fetchData();
          }
          setRefresh(!refresh);
        } else {
          setRefresh(!refresh);
        }
      } catch (err) {
        setRefresh(!refresh);
        console.log("err: ", err);
      }
    } else {
      // setGoogleLoginShow(true)
    }
  };

  async function PlaylistWatchLaterRemove(item, index) {
    try {
      if (auth) {
        const { data } = await apiCall(
          "DELETE",
          `${ApiEndPoint.PLAYLISTWATCHLATERREMOVE}/${item.id}`
        );
        if (data.length > 0) {
          const removeWatchLatedVieo = watchLaterPlaylist.filter(
            (x) => x.id != item.id
          );
          setWatchLaterPlayList(removeWatchLatedVieo);
          if (removeWatchLatedVieo.length <= 1) {
            fetchData();
          }
          setRefresh(!refresh);
          setIsLoading(false);
        } else {
          setRefresh(!refresh);
          setIsLoading(false);
        }
      }
    } catch (err) {
      setRefresh(!refresh);
      setIsLoading(false);
    }
  }

  async function myFavouritePlaylist(item, index) {
    try {
      if (auth) {
        watchLaterPlaylist[index].favourite = item.favourite ? false : true;
        const { data } = await apiCall(
          "POST",
          `${ApiEndPoint.MYFAVOURITEPLAYLIST}/${item.id}`
        );
        if (data.length > 0) {
          setRefresh(!refresh);
          setIsLoading(false);
        } else {
          setRefresh(!refresh);
          setIsLoading(false);
        }
      }
    } catch (err) {
      setRefresh(!refresh);
      setIsLoading(false);
    }
  }

  async function myFavouritePlaylistRemove(item, index) {
    try {
      if (auth) {
        watchLaterPlaylist[index].favourite = item.favourite ? false : true;
        const { data } = await apiCall(
          "DELETE",
          `${ApiEndPoint.MYFAVOURITEPLAYLISTREMOVE}/${item.id}`
        );
        if (data.length > 0) {
          setRefresh(!refresh);
          setIsLoading(false);
        } else {
          setRefresh(!refresh);
          setIsLoading(false);
        }
      }
    } catch (err) {
      setRefresh(!refresh);
      setIsLoading(false);
    }
  }

  async function watchLaterSavePlayListFun(id) {
    if (auth) {
      try {
        const { data } = await apiCall(
          "POST",
          `${ApiEndPoint.PLAYLISTWATCHLATERSAVE}/${id}`
        );
        if (data.length > 0) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (err) {
        setIsLoading(false);
      }
    }
  }
  const individualPlayListNav = (item, type) => {
    watchLaterSavePlayListFun(item.id);
    navigate("/individualPlayList", {
      state: { playListDetails: item, playListType: type },
    });
  };

  function takeSubcription(params) {
    params?.subscriptionName
      ? confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="card">
                <div className="info__padding">
                  <h3>
                    {`Please Subscribe to ${params?.subscriptionName} plan to play this video. `}
                  </h3>
                  <h3>{!auth ? "Sign In To Subscribe..." : ""}</h3>
                </div>
                {!auth ? (
                  <>
                    <div className="button__group">
                      <Button
                        onClick={() => {
                          // signIn();
                          // onClose();
                        }}
                        variant="contained"
                        className="signBtnHome"
                      >
                        {/* <img className="g-icon" src={Google}></img> */}
                        Sign-in
                      </Button>
                      <button
                        className="no-btn"
                        // onClick={onClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="button__group">
                      <Button
                        onClick={() => {
                          navigate("/subscriptionPlanList");
                          onClose();
                        }}
                        variant="contained"
                        className="subscriptionBtn"
                        // className="signBtnHome"
                      >
                        {/* <img className="g-icon" src={Google}></img> */}
                        Subscribe
                      </Button>
                      <button className="no-btn" onClick={onClose}>
                        Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            );
          },
        })
      : confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="card">
                <div className="info__padding">
                  <h3>{`This Video is not yet available`}</h3>
                </div>
                <div className="button__group">
                  <button className="button btn-ok" onClick={onClose}>
                    Ok
                  </button>
                </div>
              </div>
            );
          },
        });
  }

  function playListVideoSearchHandle(e) {
    if (!emojiRegex.test(e.target.value)) {
      if (e.target.value) {
        setSearchText(e.target.value);
      } else {
        setSearchText(null);
      }
    }
  }

  const handleTabChange = (event, newValue) => {
    setPageNo(0);
    setHasMore(true);
    setScrollLast(true);
    setTabValue(newValue);
    const updateArray = activetabs.map((item) => {
      if (item.page === "watchLater") {
        return {
          ...item,
          active: newValue,
        };
      } else {
        return {
          ...item,
          active: "videos",
        };
      }
    });
    setActiveTabs(updateArray);
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#FFB200",
      fontSize: 15,
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 600,
      textTransform: "uppercase",
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 5,
      alignItems: "flex-start",
      marginRight: 15,
      justifyContent: "end",
    },

    "&.MuiTab-root": {
      fontSize: 15,
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 600,
      textTransform: "uppercase",
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 5,
      alignItems: "flex-start",
      marginRight: 15,
      justifyContent: "end",
      minWidth: "auto",
    },
  });

  const [isOpenSortBy, setIsOpenSortBy] = useState(false);

  const openModalSortBy = () => {
    setIsOpenSortBy(true);
  };

  const closeModalSortBy = () => {
    setIsOpenSortBy(false);
  };

  function MinutesToHoursMinutes(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return hours + ":" + remainingMinutes;
  }
  const handleRadioChange = (event) => {
    setSelectedFilterOp(event.target.value);
  };
  function capitalizeFirstWord(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const handleToggleListView = () => {
    setIsListView((prevView) => !prevView);
  };
  return (
    <>
      <InfiniteScroll
        dataLength={
          tabValue === "videos"
            ? watchLaterVideos?.length
            : watchLaterPlaylist?.length
        }
        next={fetchMoreData}
        hasMore={hasMore}
        loader={
          scrollLast ? (
            isLoading && (
              <center>
                <img
                  src={loader}
                  alt="loading..."
                  style={{ height: 25, width: 25, marginTop: 20 }}
                />
              </center>
            )
          ) : (
            <p className="subtitle fancy">
              <span>End of results</span>
            </p>
          )
        }
      >
        <div className="watch-later-play-outer-wrap">
          <div className="watch-later-heading-div">
            <span className="watch-later-d-flex">
              <img
                className="watch-later-c-pointer"
                src={AllImages.YellowArrow}
                onClick={() => navigate(-1)}
                alt="Back Arrow"
                title="Back Arrow"
              ></img>
              <p className="watch-later-title">Watch Later</p>
            </span>
          </div>
          {/*----- Videos, Playlists Tab Bar and Search Bar -----*/}
          <div className="watch-later-tab-div">
            <Box className="watch-later-tab-a-center">
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#FFB200",
                    minWidth: "auto",
                  },
                }}
                aria-label="secondary tabs example"
              >
                <StyledTab value="videos" label="Satsang" />
                <StyledTab value="playlists" label="Playlists" />
              </Tabs>
            </Box>

            <div className="search-wrap">
              <div className="search-input">
                <span onClick={fetchData} className="search-icon">
                  {isLoading ? (
                    <img
                      src={loader}
                      alt="loading..."
                      style={{ height: 15, width: 15 }}
                    />
                  ) : (
                    <div className="searchTooltip">
                      <img src={AllImages.Search} alt="Search" title="Search" />
                      <span className="tooltiptext">{"Search"}</span>
                    </div>
                  )}
                  {/* <img src={AllImages.Search} alt="Search" title="Search" /> */}
                </span>
                <input
                  className="f-poppins"
                  type="text"
                  placeholder="Search for Video"
                  onChange={(e) => playListVideoSearchHandle(e)}
                  onKeyUp={handleKeyPress}
                />
              </div>
              <div className="searchIcon-outer">
                <img
                  src={AllImages.SearchIcon}
                  alt="Search"
                  title="Search"
                  className="searchIcon"
                />
              </div>
              <div
                className="filter-icon sortbyTooltip"
                onClick={() => openModalSortBy()}
              >
                <img src={AllImages.SearchToggle} alt="Search" title="Search" />
                <span className="tooltiptext">{"Sort By"}</span>
              </div>
              <span 
              className="view-toggle"
              onClick={handleToggleListView}
            >
              { isListView ? (
                <CiGrid2V  strokeWidth={1} size={20} color="#F6AE06" className="viewToggleIcon" />
              ) : (
                <CiCircleList strokeWidth={1}  size={20} color="#F6AE06" className="viewToggleIcon" />
              )}
            </span>
            </div>
          </div>

          {/*----- Video Card  -----*/}
          {tabValue == "videos" && (
            <div className={`custom-row ${isListView ? `listView` : null}`}>
              {watchLaterVideos.length > 0
                ? watchLaterVideos?.map((item, index) => (
                    <div className="custom-col-4 custom-col">
                      <div className="watch-later-play-card-wrap" key={index}>
                        <div
                          className="watch-later-play-inside-wrap"
                          style={{ position: "relative" }}
                        >
                          {item.videoUrl ? (
                            <div
                              className="watch-later-play-list-image"
                              onClick={() => handleVideoClick(item)}
                            >
                              <img
                                className={`watch-later-img-banner ${
                                  getImageNameFromResolution(
                                    item?.thumbnails
                                  ) != "maxresdefault" && "image-resolution"
                                }`}
                                src={
                                  item?.thumbnails
                                    ? `${item?.thumbnails}`
                                    : `${AllImages.DefaultThumbnail}`
                                }
                                key={item.id}
                                alt="Card Image"
                                title="Card Image"
                              />
                              <div className="playIconTooltip">
                                <img
                                  className="watch-later-play-play-icon"
                                  src={AllImages.PlayIcon}
                                  alt="play Icon"
                                  title="Play Icon"
                                />
                                <span className="tooltiptext">
                                  {"Play Video"}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="watch-later-play-list-image"
                              style={{ position: "static" }}
                            >
                              <div onClick={() => takeSubcription(item)}>
                                <img
                                  className={`watch-later-img-banner ${
                                    getImageNameFromResolution(
                                      item?.thumbnails
                                    ) != "maxresdefault" && "image-resolution"
                                  }`}
                                  src={
                                    item?.thumbnails
                                      ? `${item?.thumbnails}`
                                      : `${AllImages.DefaultThumbnail}`
                                  }
                                  alt="Banner"
                                  title="Banner"
                                />
                                <div className="layerImage"></div>
                              </div>
                              <div className="star1 badgestarInvisible">
                                <div className="LikeCount badgeShow">
                                  <i
                                    className="fa fa-lock"
                                    onClick={() => takeSubcription(item)}
                                  ></i>
                                </div>
                                <span className="tooltiptext">
                                  {"Subscribe for more Videos"}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="watch-later-play-card-content-item">
                            <div className="watch-later-play-video-content">
                              <div>
                                <p className="watch-later-play-title-text f-poppins">
                                  {item.videoTitle}
                                </p>
                                <p className="watch-later-play-text-hrs f-poppins">
                                  {MinutesToHoursMinutes(item?.videoDuration)}{" "}
                                  hrs
                                </p>
                              </div>
                              <div className="watch-later-mt-10 d-flex align-center">
                                {/* <img onClick={() => videoWatchLater(item)} src={AllImages.SelectedTimer}></img> */}
                                <div className="timerTooltip">
                                  <img
                                    onClick={() => videoWatchLater(item)}
                                    src={AllImages.SelectedTimer}
                                    alt="Timer"
                                    title="Timer"
                                  ></img>
                                  <span className="tooltiptext">
                                    {"Remove from Watch Later"}
                                  </span>
                                </div>
                                <div className="favTooltip">
                                  <img
                                    src={
                                      item?.myFavourite
                                        ? AllImages.Favorite_sel
                                        : AllImages.Fav
                                    }
                                    alt="Favourite"
                                    title="Favourite"
                                    onClick={() => addFavorite(item, index)}
                                  ></img>
                                  <span className="tooltiptext">
                                    {!item.myFavourite
                                      ? "Mark Favorite"
                                      : "Unfavorite"}
                                  </span>
                                </div>
                                <RWebShare
                                  data={{
                                    // text: "Like humans, flamingos make friends for life",
                                    url: `${VideoPlaylistShareUrl}/videoPlayPage/${item.id}`,
                                    title: "Video Share",
                                  }}
                                  onClick={() => console.log("share")}
                                >
                                  <div className="copyTooltip">
                                    <img
                                      src={AllImages.Copy}
                                      alt="Copy"
                                      title="Copy"
                                    ></img>
                                    <span className="tooltiptext">
                                      {"Copy"}
                                    </span>
                                  </div>
                                </RWebShare>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : !isLoading && <NoDataAvailable />}
            </div>
          )}

          {/*----- Play list Card  -----*/}
          {tabValue == "playlists" && (
            <div className={`custom-row ${isListView ? `listView` : null}`}>
              {watchLaterPlaylist.length > 0
                ? watchLaterPlaylist?.map((item, index) => (
                    <div className="custom-col-4 custom-col">
                      <div className="watch-later-play-card-wrap" key={index}>
                        <div
                          className="watch-later-play-inside-wrap"
                          style={{ position: "relative" }}
                        >
                          <div
                            className="watch-later-play-list-image"
                            onClick={() => {
                              individualPlayListNav(item, "admin");
                            }}
                          >
                            <img
                              className="watch-later-img-banner"
                              src={
                                item?.thumbnail
                                  ? `${GLOBAL_URL}/system/playlist/thumbnail/${item.id}`
                                  : `${AllImages.DefaultThumbnail}`
                              }
                              key={item.id}
                              alt="Card Image"
                              title="Card Image"
                            />
                            <div className="playIconTooltip">
                              <img
                                className="watch-later-play-play-icon"
                                src={AllImages.PlayIcon}
                                alt="play Icon"
                                title="Play Icon"
                              />
                              <span className="tooltiptext">
                                {"Play Video"}
                              </span>
                            </div>
                          </div>
                          <div className="watch-later-play-card-content-item">
                            <div className="watch-later-play-video-content">
                              <div>
                                <p className="watch-later-play-title-text f-poppins">
                                  {item.playlistName}
                                </p>
                                <div
                                  style={{ gap: "10px" }}
                                  className="general-textDetails general-text-hrs f-poppins"
                                >
                                  <p className="general-text-hrs">
                                    {/* {item.videoDuration}{" "} */}
                                    {item.videoDuration
                                      ? `${item.videoDuration} hrs`
                                      : "0 hrs"}
                                  </p>
                                  <p className="general-text-hrs">•</p>
                                  <p className="general-text-hrs">
                                    {/* {item.noOfVideos}{" "} */}
                                    {item.noOfVideos
                                      ? `${item.noOfVideos} videos`
                                      : "0 videos"}
                                  </p>
                                </div>
                              </div>
                              <div className="watch-later-mt-10 d-flex align-center">
                                <div className="timerTooltip">
                                  <img
                                    onClick={() =>
                                      PlaylistWatchLaterRemove(item)
                                    }
                                    src={AllImages.SelectedTimer}
                                    alt="Timer"
                                    title="Timer"
                                  ></img>
                                  <span className="tooltiptext">
                                    {"Remove Watch Later"}
                                  </span>
                                </div>
                                <div className="favTooltip">
                                  <img
                                    onClick={() =>
                                      item.favourite
                                        ? myFavouritePlaylistRemove(item, index)
                                        : myFavouritePlaylist(item, index)
                                    }
                                    src={
                                      item.favourite
                                        ? AllImages.Favorite_sel
                                        : AllImages?.Fav
                                    }
                                    alt="Favourite"
                                    title="Favourite"
                                  ></img>
                                  <span className="tooltiptext">
                                    {!item.favourite
                                      ? "Mark Favorite"
                                      : "Unfavorite"}
                                  </span>
                                </div>
                                {/* <div className='copyTooltip'>
                              <img
                                src={AllImages.Copy}
                                alt="Copy"
                                title="Copy"
                              ></img>
                              <span className='tooltiptext'>
                                {"Copy"}
                              </span>
                            </div> */}
                                {/* <RWebShare
                            data={{
                              url: `${VideoPlaylistShareUrl}/videoPage/${item.id}`,
                              title: "Video Share",
                            }}
                            onClick={() => console.log('share')}
                          >
                            <img src={AllImages.Copy}></img>
                          </RWebShare> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : !isLoading && <NoDataAvailable />}
            </div>
          )}
        </div>
      </InfiniteScroll>

      {isOpenSortBy && (
        <Dialog
          open={openModalSortBy}
          className="sortBy"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent
            style={{
              overflowY: "hidden",
              overflowX: "hidden",
            }}
          >
            <div className="qu-history-modal-msg-content">
              <p className="qu-history-modal-msg-text">{"Sort by"}</p>
              <span
                className="qu-history-modal-close-button"
                onClick={() => closeModalSortBy()}
              >
                &times;
              </span>
            </div>
            <ul>
              {(tabValue === "videos"
                ? Object.keys(SortingOptions)
                : [
                    "NEWLY_ADDED",
                    "LAST_MODIFIED_DATE",
                    "PREVIOUSLY_ADDED",
                    "Sort_A_To_Z",
                    "Sort_Z_To_A",
                  ]
              ).map((key) => (
                <li key={key}>
                  <label className="customRadio">
                    {SortingOptions[key] === "A_TO_Z" ||
                    SortingOptions[key] === "Z_TO_A"
                      ? key.replace(/_/g, " ")
                      : capitalizeFirstWord(
                          key.replace(/_/g, " ").toLowerCase()
                        )}
                    <input
                      type="radio"
                      value={SortingOptions[key]}
                      checked={selectedFilterOp === SortingOptions[key]}
                      onChange={handleRadioChange}
                      name="radio"
                    />
                    <span className="checkmark"></span>
                  </label>
                </li>
              ))}
            </ul>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
export default WatchLater;
